import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getWasteToLandfillData, getWasteToLandfillDataTotals, postWasteToLandfillData } from '../../../../../actions/carbonfootprint-rework/05-indirect-ghg-emissions-from-other-sources/01-waste-to-landfill-actions';
import { getWasteToRecyclingData, getWasteToRecyclingDataTotals, postWasteToRecyclingData } from '../../../../../actions/carbonfootprint-rework/05-indirect-ghg-emissions-from-other-sources/02-waste-to-recycling-actions';
import { getWasteToCompostingData, getWasteToCompostingDataTotals, postWasteToCompostingData } from '../../../../../actions/carbonfootprint-rework/05-indirect-ghg-emissions-from-other-sources/03-waste-to-composting-actions';
import { getWasteToWaterTreatmentData, getWasteToWaterTreatmentDataTotals, postWasteToWaterTreatmentData } from '../../../../../actions/carbonfootprint-rework/05-indirect-ghg-emissions-from-other-sources/05-waste-to-water-treatment-actions';
import { getWasteToBiocharProductionData, getWasteToBiocharProductionDataTotals, postWasteToBiocharProductionData } from '../../../../../actions/carbonfootprint-rework/05-indirect-ghg-emissions-from-other-sources/04-waste-to-biochar-actions';
import { wasteToBiocharProductionColumns, wasteToBiocharProductionGrandTotalFields, wasteToBiocharProductionTotalColumns, wasteToCompostingColumns, wasteToCompostingGrandTotalFields, wasteToCompostingTotalColumns, wasteToLandfillColumns, wasteToLandfillGrandTotalFields, wasteToLandfillTotalColumns, wasteToRecyclingColumns, wasteToRecyclingGrandTotalFields, wasteToRecyclingTotalColumns, wastewaterTreatmentColumns, wastewaterTreatmentGrandTotalFields, wastewaterTreatmentTotalColumns } from '../constants/category-five-columns';
import useTsPaginator from 'ts-paginator';
import { MONTHMAPPER } from '../constants/months';
import { uploadCsvDocument } from '../../../../../actions/carbonfootprint-rework/00-base/00-base-actions';

export function useCategoryFiveDataStore(selectedCategory, year, company, group, facility) {
    const dispatch = useDispatch();
    const [month, setMonth] = useState(0);

    // --- declare useSelector variables ---
    const wasteToLandfillData = useSelector((state) => state.indirectGhgEmissionsFromOtherSourcesForWasteToLandfill.wasteToLandfillData?.data)
    const wasteToLandfillTableRecords = useSelector((state) => state.indirectGhgEmissionsFromOtherSourcesForWasteToLandfill.wasteToLandfillData?.pagination?.total_records);
    const wasteToLandfillTotals = useSelector((state) => state.indirectGhgEmissionsFromOtherSourcesForWasteToLandfill.wasteToLandfillDataTotals?.data)
    const wasteToRecyclingData = useSelector((state) => state.indirectGhgEmissionsFromOtherSourcesForWasteToRecycling.wasteToRecyclingData?.data)
    const wasteToRecyclingTableRecords = useSelector((state) => state.indirectGhgEmissionsFromOtherSourcesForWasteToRecycling.wasteToRecyclingData?.pagination?.total_records);
    const wasteToRecyclingTotals = useSelector((state) => state.indirectGhgEmissionsFromOtherSourcesForWasteToRecycling.wasteToRecyclingDataTotals?.data)
    const wasteToCompostingData = useSelector((state) => state.indirectGhgEmissionsFromOtherSourcesForWasteToComposting.wasteToCompostingData?.data)
    const wasteToCompostingTableRecords = useSelector((state) => state.indirectGhgEmissionsFromOtherSourcesForWasteToComposting.wasteToCompostingData?.pagination?.total_records);
    const wasteToCompostingTotals = useSelector((state) => state.indirectGhgEmissionsFromOtherSourcesForWasteToComposting.wasteToCompostingDataTotals?.data)
    const wastewaterTreatmentData = useSelector((state) => state.indirectGhgEmissionsFromOtherSourcesForWasteToWaterTreatmentReducer.wasteToWaterTreatmentData?.data)
    const wastewaterTreatmentTableRecords = useSelector((state) => state.indirectGhgEmissionsFromOtherSourcesForWasteToWaterTreatmentReducer.wasteToWaterTreatmentData?.pagination?.total_records);
    const wastewaterTreatmentTotals = useSelector((state) => state.indirectGhgEmissionsFromOtherSourcesForWasteToWaterTreatmentReducer.wasteToWaterTreatmentDataTotals?.data)
    const wasteToBiocharData = useSelector((state) => state.indirectGhgEmissionsFromOtherSourcesForWasteToBiocharProduction.wasteToBiocharProductionData?.data)
    const wasteToBiocharTableRecords = useSelector((state) => state.indirectGhgEmissionsFromOtherSourcesForWasteToBiocharProduction.wasteToBiocharProductionData?.pagination?.total_records);
    const wasteToBiocharTotals = useSelector((state) => state.indirectGhgEmissionsFromOtherSourcesForWasteToBiocharProduction.wasteToBiocharProductionDataTotals?.data)

    // --- variable manipulation, to make hook call cleaner ---

    const selectedCategoryDataMap = {
        'Waste to Landfill': {
            data: wasteToLandfillData,
            totals: wasteToLandfillTotals,
            getDataAction: getWasteToLandfillData,
            getTotalsAction: getWasteToLandfillDataTotals,
            postDataAction: postWasteToLandfillData,
            categoryKey: 'landfill',
            columns: wasteToLandfillColumns,
            totalColumns: wasteToLandfillTotalColumns,
            grandTotalFields: wasteToLandfillGrandTotalFields,
            tableRecordCount: wasteToLandfillTableRecords,
        },
        'Waste to Recycling': {
            data: wasteToRecyclingData,
            totals: wasteToRecyclingTotals,
            getDataAction: getWasteToRecyclingData,
            getTotalsAction: getWasteToRecyclingDataTotals,
            postDataAction: postWasteToRecyclingData,
            categoryKey: 'recycling',
            columns: wasteToRecyclingColumns,
            totalColumns: wasteToRecyclingTotalColumns,
            grandTotalFields: wasteToRecyclingGrandTotalFields,
            tableRecordCount: wasteToRecyclingTableRecords,
        },
        'Waste to Composting': {
            data: wasteToCompostingData,
            totals: wasteToCompostingTotals,
            getDataAction: getWasteToCompostingData,
            getTotalsAction: getWasteToCompostingDataTotals,
            postDataAction: postWasteToCompostingData,
            categoryKey: 'composting',
            columns: wasteToCompostingColumns,
            totalColumns: wasteToCompostingTotalColumns,
            grandTotalFields: wasteToCompostingGrandTotalFields,
            tableRecordCount: wasteToCompostingTableRecords,
        },
        'Wastewater Treatment': {
            data: wastewaterTreatmentData,
            totals: wastewaterTreatmentTotals,
            getDataAction: getWasteToWaterTreatmentData,
            getTotalsAction: getWasteToWaterTreatmentDataTotals,
            postDataAction: postWasteToWaterTreatmentData,
            categoryKey: 'waste-to-water-treatment',
            columns: wastewaterTreatmentColumns,
            totalColumns: wastewaterTreatmentTotalColumns,
            grandTotalFields: wastewaterTreatmentGrandTotalFields,
            tableRecordCount: wastewaterTreatmentTableRecords,
        },
        'Waste to Biochar Production': {
            data: wasteToBiocharData,
            totals: wasteToBiocharTotals,
            getDataAction: getWasteToBiocharProductionData,
            getTotalsAction: getWasteToBiocharProductionDataTotals,
            postDataAction: postWasteToBiocharProductionData,
            categoryKey: 'biochar-production',
            columns: wasteToBiocharProductionColumns,
            totalColumns: wasteToBiocharProductionTotalColumns,
            grandTotalFields: wasteToBiocharProductionGrandTotalFields,
            tableRecordCount: wasteToBiocharTableRecords,
        }
    }

    const {
        data,
        totals,
        getDataAction,
        getTotalsAction,
        postDataAction,
        categoryKey,
        columns,
        totalColumns,
        grandTotalFields,
        tableRecordCount
    } = selectedCategoryDataMap[selectedCategory] ||
        {
            data: null,
            totals: null,
            getDataAction: null,
            getTotalsAction: null,
            postDataAction: null,
            categoryKey: null,
            columns: [],
            totalColumns: [],
            grandTotalFields: [],
            tableRecordCount: 0
        };

    const {
        totalRecordCount,
        rowsPerPage,
        currentPage,
        _determinePaginationMessage,
        _determinePaginationDisabledState,
        // _determinePaginationPages,
        _determineRowsPerPageOptions,
        _handleChangeTotalRecordCount,
        _handleChangeRowsPerPage,
        _handleChangePage,
    } = useTsPaginator(+tableRecordCount || 0, 0);

    useEffect(() => {
        // if (currentProjectId !== projectId) {
        _handleChangePage(0); // Reset to the first page
        _handleChangeRowsPerPage(10)
        _handleChangeTotalRecordCount(+tableRecordCount); // Reset to the first page
        // }
    }, [tableRecordCount]);

    useEffect(() => {
        const monthForBackend = MONTHMAPPER[month];
        if (selectedCategory === 'Waste to Landfill') {
            dispatch(getWasteToLandfillData(year, facility, rowsPerPage, currentPage, monthForBackend))
        }
        if (selectedCategory === 'Waste to Recycling') {
            dispatch(getWasteToRecyclingData(year, facility, rowsPerPage, currentPage, monthForBackend))
        }
        if (selectedCategory === 'Waste to Composting') {
            dispatch(getWasteToCompostingData(year, facility, rowsPerPage, currentPage, monthForBackend))
        }
        if (selectedCategory === 'Wastewater Treatment') {
            dispatch(getWasteToWaterTreatmentData(year, facility, rowsPerPage, currentPage, monthForBackend))
        }
        if (selectedCategory === 'Waste to Biochar Production') {
            dispatch(getWasteToBiocharProductionData(year, facility, rowsPerPage, currentPage, monthForBackend))
        }

    }, [dispatch, selectedCategory, year, facility, group, company, rowsPerPage, currentPage]
    )

    return {
        month,
        setMonth,
        data,
        totals,
        getDataAction,
        getTotalsAction,
        postDataAction,
        uploadCsvDocument,
        categoryKey,
        columns,
        totalColumns,
        grandTotalFields,
        year,
        facility,
        group,
        company,
        // pagination
        totalRecordCount,
        rowsPerPage,
        currentPage,
        _determinePaginationMessage,
        _determinePaginationDisabledState,
        // _determinePaginationPages,
        _determineRowsPerPageOptions,
        _handleChangeTotalRecordCount,
        _handleChangeRowsPerPage,
        _handleChangePage,
    }
}